import {put, takeLatest} from 'redux-saga/effects';
import {ROUTES_FETCH_API_ROUTES, ROUTES_FETCH_CLIENT_ROUTES} from './constants';
import {appLoadInitValues} from '../app/actions';

export function* fetchApiRoutesSaga() {
	yield takeLatest(ROUTES_FETCH_API_ROUTES, function* () {
		yield put(appLoadInitValues());
	});
}

export function* fetchClientRoutesSaga() {
	yield takeLatest(ROUTES_FETCH_CLIENT_ROUTES, function* () {
		yield put(appLoadInitValues());
	});
}
